__turbopack_context__.v({
  "center": "styles-module__87jLXq__center",
  "content": "styles-module__87jLXq__content",
  "grid": "styles-module__87jLXq__grid",
  "gridContainer": "styles-module__87jLXq__gridContainer",
  "gridItem": "styles-module__87jLXq__gridItem",
  "heading": "styles-module__87jLXq__heading",
  "icon": "styles-module__87jLXq__icon",
  "left": "styles-module__87jLXq__left",
  "right": "styles-module__87jLXq__right",
  "title": "styles-module__87jLXq__title",
});
